<template>
    <v-container grid-list-sm text-xs-left>
        <v-flex>
            <v-form ref="form">
                <v-text-field
                        v-model="name"
                        label="Name"
                        :rules="[rules.required, rules.max, rules.min3]"
                        :counter="50"
                        required
                        @input="$v.name.$touch()"
                        @blur="$v.name.$touch()"
                />
                <v-text-field
                        v-model="surname"
                        :rules="[rules.required, rules.max, rules.min3]"
                        label="Surname"
                        :counter="50"
                        required
                        @input="$v.surname.$touch()"
                        @blur="$v.surname.$touch()"
                />

                <v-text-field
                        v-model="email"
                        :rules="[rules.email,rules.required]"
                        label="E-mail"
                        required
                        @input="$v.email.$touch()"
                        @blur="$v.email.$touch()"
                />
                <v-text-field
                        v-model="company"
                        label="Company"
                        required
                        :rules="[rules.required, rules.max, rules.min3]"
                        :counter="50"
                        @input="$v.company.$touch()"
                        @blur="$v.company.$touch()"
                />

                <v-flex >
                    <p class="subheading">Read <a download @click="privacyDowloaded=true" href="docs/Information Notice of NTT DATA Italia S.p.A.pdf">here</a> NTT DATA Information Policy</p>
                </v-flex>
                <v-flex>
                    <v-checkbox
                            v-model="checkbox"
                            label="I declare to have read and understood the privacy policy according to the European regulation n. 2016/679 (c.d. GDPR) on the processing of personal data"
                    ></v-checkbox>
                </v-flex>

                <v-flex class="mt-3">
                    <v-btn :disabled="!privacyDowloaded || !checkbox" :dark="privacyDowloaded && checkbox" round color="green" @click="submit">
                        Submit
                    </v-btn>
                    <v-btn round dark color="red" @click="clear">
                        Clear
                    </v-btn>
                </v-flex>
            </v-form>
        </v-flex>


        <v-dialog v-model="registrationStatus" max-width="450">
            <v-card v-if="registrationError===200">
                <v-card-title class="headline success white--text">Contact correctly saved</v-card-title>
                <v-card-text>Your contact has been successfully saved.</v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title class="headline error white--text">Saving failed</v-card-title>
                <v-card-text>Something went wrong... Retry!</v-card-text>
            </v-card>
        </v-dialog>
    </v-container>

</template>


<script>
    import {validationMixin,} from "vuelidate";
    import {email, maxLength, minLength, required,sameAs} from "vuelidate/lib/validators";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";


    export default {
        name: "ContactsRegistrationGhost",
        components: {},
        mixins: [validationMixin,],
        validations: {
            name: {required, minLength: minLength(3), maxLength: maxLength(50)},
            surname: {required, minLength: minLength(3), maxLength: maxLength(50)},
            company: {required, minLength: minLength(3), maxLength: maxLength(50)},
            email: {email,required},
        },

        data() {
            return {
                rules: {
                    required: value => !!value || 'Required',
                    min3: v => v.length >= 3 || 'This field must be at least 3 characters long',
                    max: v => v.length <= 50 || 'This field must be at most 32 characters long',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return value === '' || pattern.test(value) || 'Invalid e-mail'
                    }
                },
                name: "",
                surname: "",
                email: "",
                company: "",
                registrationStatus: false,
                registrationError: 200,
                checkbox: false,
                privacyDowloaded: false,

            };
        },
        methods: {
            setCheckbox(value){
                this.checkbox = value;
            },
            submit() {
                this.$v.$touch();
                if(this.$refs.form.validate()) {
                    let requestUrl = {
                        url: UrlsService.contactsGhost,
                        timeout: TimeService.secondsToMillis(0),
                    };
                    let requestData = {
                        interactionData: {
                            text: "CREATE",
                            contactRequest: {
                                contact: {
                                    name: this.name,
                                    surname: this.surname,
                                    email: this.email,
                                    company: this.company,
                                }
                            },
                        }
                    };
                    let requestObject = {
                        type: "normal",
                        urlsInfo: requestUrl,
                        data: {
                            data: requestData
                        },
                    };
                    let messages = {
                        title: "Create new user",
                        loading: "Creating",
                        error: "Server Error",
                    };
                    let options = {
                        loadingType: "fullscreen",
                        timeout: TimeService.secondsToMillis(0),
                    };

                    APILoaderDecoratorService.setLoader(requestObject, messages, options)
                        .then(responseSuccess => {
                            let response = responseSuccess;
                            this.registrationStatus = true;
                            if(response.response !== undefined) {
                                this.registrationError = response.response.status;
                            } else{
                                this.registrationError = 200;
                                this.$emit("submit")
                                this.clear();
                            }

                        });

                }
            },
            clear() {
                this.name= "";
                this.surname= "";
                this.email= "";
                this.company= "";
            },

        },
    };
</script>

<style lang="scss">

</style>
